export const formatEnergy = (energy?: number | null): string => {
  if (!energy) return `0`

  return Intl.NumberFormat(`en-US`, {
    maximumFractionDigits: 0,
  }).format(Number.isNaN(energy) ? 0 : energy)
}
